import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-accountantdashboard',
  templateUrl: './accountantdashboard.component.html',
  styleUrls: ['./accountantdashboard.component.scss']
})
export class AccountantdashboardComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
